import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';
import { PayloadAction } from '@reduxjs/toolkit';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';
import { TGetCustomerDetailsReduxParams } from '~types/feat/customer';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetCustomerDetails(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerDetailsAttempt', handleGetCustomerDetails, api);
}

function* handleGetCustomerDetails(api: CustomerGateway, data: PayloadAction<TGetCustomerDetailsReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const { customerId } = data.payload;

    if (!customerId) {
        yield put(combinedActions.customerGetCustomerDetailsFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        toast.error(ErrorMessages.GenericRequiredFieldNotFilledIn);
        return;
    }

    const response = yield* call([api, api.getCustomerDetails], {
        authToken,
        customerId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerDetailsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const {
            data: responseData,
        } = response;

        yield put(combinedActions.customerGetCustomerDetailsSuccess(responseData));
    }
}
